var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F1F2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4141 11.9998L17.7071 7.70676C18.0981 7.31576 18.0981 6.68376 17.7071 6.29276C17.3161 5.90176 16.6841 5.90176 16.2931 6.29276L12.0001 10.5858L7.70713 6.29276C7.31613 5.90176 6.68413 5.90176 6.29313 6.29276C5.90213 6.68376 5.90213 7.31576 6.29313 7.70676L10.5861 11.9998L6.29313 16.2928C5.90213 16.6838 5.90213 17.3158 6.29313 17.7068C6.48813 17.9018 6.74413 17.9998 7.00013 17.9998C7.25613 17.9998 7.51213 17.9018 7.70713 17.7068L12.0001 13.4138L16.2931 17.7068C16.4881 17.9018 16.7441 17.9998 17.0001 17.9998C17.2561 17.9998 17.5121 17.9018 17.7071 17.7068C18.0981 17.3158 18.0981 16.6838 17.7071 16.2928L13.4141 11.9998Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2b0cb5e69ea8dbc770e1ec58a2f99470.svg";
export { ForwardRef as ReactComponent };